// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__3a5H_","codeContainer":"Text_codeContainer__2CfA_","copy":"Text_copy__2ZrQR"};